import constants from "../config/constants";

const $inject = ['$q', '$injector', 'dataSourceService'];

const authInterceptor = function ($q, $injector, dataSourceService) {
  let factory = {};
  factory.request = request;
  factory.responseError = responseError;

  function request(config) {
    if (dataSourceService.dataSource === constants.DATA_SOURCES.ODATA) {
      let authService = $injector.get('authService');
      let accessToken = authService.getAccessToken();

      if (accessToken) {
        config.headers.Authorization = 'Bearer ' + accessToken;
      }
    }

    return config;
  }

  function responseError(rejection) {
    let deferred = $q.defer();

    if (rejection.status === 401 && dataSourceService.dataSource === constants.DATA_SOURCES.ODATA) {
      let authService = $injector.get('authService');
      authService.logout();
    } else {
      deferred.reject(rejection);
    }

    return deferred.promise;
  }

  return factory;
};

authInterceptor.$inject = $inject;

export default authInterceptor;



// WEBPACK FOOTER //
// ./src/factories/authInterceptor.js